export default "__VITE_ASSET__DB_w9d7b__"